"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, TextInput } from "@mantine/core";
export default function ProductQuantity(t0) {
  const $ = _c(22);
  const {
    quantity,
    setQuantity,
    max: t1
  } = t0;
  const max = t1 === undefined ? 999 : t1;
  let t2;
  if ($[0] !== max || $[1] !== quantity || $[2] !== setQuantity) {
    t2 = function increase() {
      if (quantity >= max) {
        return;
      }
      setQuantity(_temp);
    };
    $[0] = max;
    $[1] = quantity;
    $[2] = setQuantity;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const increase = t2;
  let t3;
  if ($[4] !== quantity || $[5] !== setQuantity) {
    t3 = function decrease() {
      if (quantity <= 1) {
        return;
      }
      setQuantity(_temp2);
    };
    $[4] = quantity;
    $[5] = setQuantity;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const decrease = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      border: "1px solid gray",
      borderRadius: "4px 0 0 4px"
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== decrease) {
    t5 = <Button size="compact-xl" c="black" variant="white" className="qty-btn qty-decrease" style={t4} onClick={decrease}>−</Button>;
    $[8] = decrease;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== setQuantity) {
    t6 = e => {
      const value = Number(e.target.value);
      if (!value || value < 1) {
        setQuantity(1);
        return;
      }
      setQuantity(value);
    };
    $[10] = setQuantity;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== quantity || $[13] !== t6) {
    t7 = <TextInput maw={75} aria-label="Quantity" type="text" className="qty-input" value={quantity} onChange={t6} />;
    $[12] = quantity;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      border: "1px solid gray",
      borderRadius: "0 4px 4px 0"
    };
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== increase) {
    t9 = <Button size="compact-xl" c="black" variant="white" className="qty-btn qty-increase" style={t8} onClick={increase}>+</Button>;
    $[16] = increase;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t5 || $[19] !== t7 || $[20] !== t9) {
    t10 = <div className="col-span-12 lg:col-span-4 flex items-center justify-center">{t5}{t7}{t9}</div>;
    $[18] = t5;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
function _temp2(prev_0) {
  return prev_0 - 1;
}
function _temp(prev) {
  return prev + 1;
}